import { useLang } from "hooks/useLang"
import { NextSeo } from "next-seo"
import NewAuthLayout from "components/Layout/newAuth/AuthLayout"
import AuthHeader from "components/page_components/auth/User/Signup/signupForm/header"
import SignUpForm from "components/page_components/auth/User/Signup/signupForm/signupForm"
export default function SignupPage() {
    const { isAr } = useLang()

    return (
        <>
            <NextSeo
                title={isAr ? "إنشاء حساب جديد" : "Create a new account"}
                description={
                    isAr
                        ? "إنشاء حساب جديد في باس تيكيتس"
                        : "Create a new account in PassTickets"
                }
                noindex
                nofollow
                openGraph={{
                    title: isAr ? "إنشاء حساب جديد" : "Create a new account",
                    description: isAr
                        ? "إنشاء حساب جديد في باس تيكيتس"
                        : "Create a new account in PassTickets",
                    url: "https://pass-tickets.com/user/signup",
                }}
            />
            <NewAuthLayout>
                <AuthHeader
                    title="create_account"
                    description="welcome_to_passtickets"
                />
                <SignUpForm />
            </NewAuthLayout>
        </>
    )
}

SignupPage.theme = "dark"
